import { render, staticRenderFns } from "./xtButton.vue?vue&type=template&id=bfd3de5e&scoped=true&"
import script from "./xtButton.vue?vue&type=script&lang=js&"
export * from "./xtButton.vue?vue&type=script&lang=js&"
import style0 from "./xtButton.vue?vue&type=style&index=0&id=bfd3de5e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd3de5e",
  null
  
)

export default component.exports